import { makeDateTimeTz } from '@/mixins/utils'
import { updateDraft } from '@/sdk/clients/ServicesRequest'
import logger from '@/sdk/logger'

const toPayload = data => {
  return {
    update: {
      type: 'scheduling',
      data: {
        booking_type: data.frequency,
        frequency: data.frequencyInfo,
        duration: data.hoursPerAppointment,
        first_appointment: {
          date: makeDateTimeTz(data.date, data.time).toISOString(),
          is_flexible: data.flexibility,
          is_all_day: data.isAllDay,
        },
        expected_appointment_schedule: {
          is_flexible:
            typeof data.recurringAppointmentsFlexibility === 'boolean'
              ? data.recurringAppointmentsFlexibility
              : true,
          preferences:
            data.recurringAppointmentsFlexibility === false
              ? data.specificTimesInfo
              : '',
        },
      },
    },
  }
}

export default {
  async submitSchedule({ rootState }, value) {
    const payload = toPayload(value)
    const draftUuid = rootState.registration.serviceRequestDraftId

    try {
      await updateDraft(payload, draftUuid)
    } catch (error) {
      logger.error('failed trying to save the schedule data', {
        error,
        tags: ['bookingFunnelSteps', 'http', 'schedule', 'step3'],
      })

      throw error
    }
  },
}
